import { UserCallAvailability } from "@redotech/redo-support-common/support/voice/voice-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createCallAvailability = {
  name: "createCallAvailability" as const,
  input: z.object({ availabilityStatus: createEnum(UserCallAvailability) }),
  output: z.object({ status: z.number() }),
};
